export const asAtomsVector = {
  data: `<svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.247064 1.425L2.4054 3.58333C2.7304 3.90833 3.2554 3.90833 3.5804 3.58333L5.73873 1.425C6.26373 0.9 5.88873 0 5.14706 0H0.830398C0.0887309 0 -0.277936 0.9 0.247064 1.425Z" fill="currentColor"/>
</svg>
  `,
  name: 'atomsVector',
};
